import { Endpoint } from "./BaseEndpoint";

export class ContactsEndpoint extends Endpoint {
    constructor() {
        super("contacts");
    }
}

export class SubscribeToNewsletterEndpoint extends ContactsEndpoint {
    constructor() {
        super();
        this.endPoint += "/subscribe_to_newsletter";
    }
}